module.exports = __webpack_public_path__ + "4ab9a8f9ffddd969a5c2a67a927e60d3.png";